var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgWeigh = function SvgWeigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1108,
    y: 15.2678,
    width: 8,
    height: 3,
    transform: "rotate(-45 10.1108 15.2678)",
    stroke: "#FF6B00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10043 12.0858C4.88148 11.3048 6.14781 11.3048 6.92886 12.0858L15.4141 20.5711C16.1952 21.3522 16.1952 22.6185 15.4141 23.3996V23.3996C14.6331 24.1806 13.3668 24.1806 12.5857 23.3996L4.10043 14.9143C3.31939 14.1332 3.31939 12.8669 4.10043 12.0858V12.0858Z",
    stroke: "#FF6B00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39344 16.3285C3.97923 15.7427 4.92898 15.7427 5.51476 16.3285L11.1716 21.9853C11.7574 22.5711 11.7574 23.5209 11.1716 24.1067V24.1067C10.5858 24.6924 9.63608 24.6924 9.0503 24.1067L3.39344 18.4498C2.80765 17.864 2.80765 16.9143 3.39344 16.3285V16.3285Z",
    stroke: "#FF6B00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5858 3.60049C13.3668 2.81944 14.6332 2.81944 15.4142 3.60049L23.8995 12.0858C24.6805 12.8668 24.6805 14.1332 23.8995 14.9142V14.9142C23.1184 15.6952 21.8521 15.6952 21.0711 14.9142L12.5858 6.42892C11.8047 5.64787 11.8047 4.38154 12.5858 3.60049V3.60049Z",
    stroke: "#FF6B00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8285 2.89342C17.4143 2.30764 18.364 2.30764 18.9498 2.89342L24.6067 8.55028C25.1925 9.13606 25.1925 10.0858 24.6067 10.6716V10.6716C24.0209 11.2574 23.0711 11.2574 22.4854 10.6716L16.8285 5.01474C16.2427 4.42896 16.2427 3.47921 16.8285 2.89342V2.89342Z",
    stroke: "#FF6B00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default __webpack_public_path__ + "static/media/weigh.21d194de.svg";
export { SvgWeigh as ReactComponent };